/**
 * @desc: 业务发行
 * @create：2020/4/15
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T2/businessIssuance'

export default {
  namespaced: true,
  actions: {
    async getListData(ctx, payload) {
      const res = await Models.getListData(payload)
      // 请求失败时返回的参数 避免报错
      const failureData = {
        total: 0,
        list: [],
        pageNum: 1,
        pages: 1
      }

      // 判断响应状态返回不同状态的数据体
      if (res && res.status === 200) {
        return res.data
      } else {
        return failureData
      }
    },

    // 获取渠道反馈信息
    async getBankFeedback(ctx, payload) {
      const res = await Models.getBankFeedback(payload)
      return res && res.status === 200 && res.data || {}
    },

    // 获取商户发行详情
    async getMerchantDetails(ctx, payload) {
      const res = await Models.getMerchantDetails(payload)
      return res && res.status === 200 && res.data || {}
    },

    // 业务发型/首次发行
    async onPublishConfirm(ctx, payload) {
      return await Models.onPublishConfirm(payload)
    },

    // 批量保理发行
    async batchConfirm(ctx, payload) {
      return await Models.batchConfirm(payload)
    }

  }
}
